import styled from "@emotion/styled";

const FormContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid #ccc;

  &::last-of-type {
    border-bottom: none;
  }
  &.override {
    border-bottom: 1px solid #F7F7F7;
  }
  &.override:last-child {
    border-bottom: none;
  }
`;

export default FormContainer;
